/**
 * CUSTOM: instant selected-value label for button variant options (vanilla JS, no jQuery).
 *
 * snippets/variant-main-picker.liquid renders "POUCH STRENGTH: 4MG" in Liquid. The theme only
 * refreshes that label after it fetches and re-renders the picker from the server, so there is a
 * visible delay. This updates the label text immediately on click; the server re-render then
 * writes the same value, so the two never disagree.
 *
 * Kept as its own file so the theme's variant-picker.js stays unedited.
 */
(function () {
  'use strict';

  var FIELDSET = '.variant-option--buttons';
  var TARGET = '.variant-option__selected-value';

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    var fieldset = input.closest(FIELDSET);
    if (!fieldset) return;

    var target = fieldset.querySelector(TARGET);
    if (target) target.textContent = input.value;
  });
})();
